/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY2FuZGlkYXRlL2NvbXBvbmVudHMvY2FuZGlkYXRlLXdvcmstZXhwZXJpZW5jZXMvY2FuZGlkYXRlLXdvcmstZXhwZXJpZW5jZXMuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvY2FuZGlkYXRlL2NvbXBvbmVudHMvY2FuZGlkYXRlLXdvcmstZXhwZXJpZW5jZXMvY2FuZGlkYXRlLXdvcmstZXhwZXJpZW5jZXMuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/candidate/components/candidate-work-experiences/candidate-work-experiences.component.scss.shim.ngstyle.ts